import { some, none, Option, fromNullable } from "./option";

export const tryNumber = (n: any) =>
  typeof n === "number" ? some(n) : (none as Option<number>);
